<template>
    <div class="lang">
        <div class="reservation-lang">
            <div class="info">
                <h3 class="bullet01">Өвчтөний мэдээлэл</h3>
                <div class="input-form mt20">
                    <ul class="input-form__list">
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>Өвчтөний бүртгэлийн дугаар <br>
                                    (Зөвхөн давтан үзүүлж буй өвчтөн)</div>
                                <div class="cont"><input type="text" class="input" placeholder="Өвчтөний бүртгэлийн дугаар"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> Нэр</div>
                                <div class="cont item2"><input type="text" class="input" placeholder="Эхнийх нь Нэр"><input type="text" class="input" placeholder="Эцэст нь Нэр"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> Хүйс</div>
                                <div class="cont">
                                    <div class="radio-wrap">
                                        <label  ><input type="radio" name="test01" id="test01" checked=""><span class="radio-btn"></span>
                                            <p>Эрэгтэй</p>
                                        </label>
                                        <label  ><input type="radio" name="test01" id="test02"><span class="radio-btn"></span>
                                            <p>Эмэгтэй</p><input type="text" disabled="">
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>Төрсөн он сар өдөр</div>
                                <div class="cont"><input type="text" class="input" placeholder="ex)19800320"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>Иргэний харьяалал</div>
                                <div class="cont"><input type="text" class="input"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> Хэл</div>
                                <div class="cont"><input type="text" class="input"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> Оршин суугаа улс</div>
                                <div class="cont">
                                    <div class="radio-wrap">
                                        <label  ><input type="radio" name="test01" id="test01" checked=""><span class="radio-btn"></span>
                                            <p>БНСУ</p>
                                        </label>
                                        <label  ><input type="radio" name="test01" id="test02"><span class="radio-btn"></span>
                                            <p>Бусад</p><input type="text" disabled="">
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit">Эх орон дахь хаяг</div>
                                <div class="cont"><input type="text" class="input"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>Солонгос дахь хаяг</div>
                                <div class="cont"><input type="text" class="input"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>Утасны дугаар</div>
                                <div class="cont">
                                    <input type="text" class="input">
                                    <!-- <p>- Please leave korean phone number or email address.</p> -->
                                </div>

                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit">Яаралтай үед холбогдох утасны дугаар</div>
                                <div class="items">
                                    <div class="cont">
                                        <div class="tit2">Нэр</div><input type="text" class="input">
                                    </div>
                                    <div class="cont">
                                        <div class="tit2">Өвчтөнтэй ямар холбоотой болох</div><input type="text" class="input">
                                    </div>
                                    <div class="cont">
                                        <div class="tit2">Утасны дугаар</div><input type="text" class="input">
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>Даатгалын мэдээлэл</div>
                                <div class="cont"><input type="text" class="input"></div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="info">
                <h3 class="bullet01">Томилгоо дэлгэрэнгүй мэдээлэл</h3>
                <div class="input-form mt20">
                    <ul class="input-form__list">
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>Өвчний шинж тэмдэг <br>
                                    (үзлэгийн цаг захиалах болсон шалтгаан)</div>
                                <div class="cont">
                                    <textarea name="" id="" class="textarea"></textarea>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>Шаардлагатай эрүүл мэндийн үйлчилгээ</div>
                                <div class="cont">
                                    <textarea name="" id="" class="textarea"></textarea>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>Сонгосон огноо, цаг</div>
                                <div class="items">
                                    <div class="cont">
                                        <div class="tit2">1 дэх</div>
                                        <div class="table-search type2">
                                            <div class="dp__input_wrap">
                                                <VueDatePicker v-model="showStartDate" locale="en" :format="formatDate" :enable-time-picker="false" week-start="0" position="left" placeholder="ex) 2025-01-01" auto-apply />
                                            </div>
                                            <div class="row">
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select01 }" @click.prevent="activeselect01">Цаг сонгоно уу</a>
                                                    <slide-up-down :active="select01" class="select-option">
                                                        <a href="" class="select-option--btn" v-for="i in 23">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                                :
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select02 }" @click.prevent="activeselect02">Минутыг сонгоно уу</a>
                                                    <slide-up-down :active="select02" class="select-option">
                                                        <a href="" class="select-option--btn" v-for="i in 59">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="cont">
                                        <div class="tit2">2 дахь</div>
                                        <div class="table-search type2">
                                            <div class="dp__input_wrap">
                                                <VueDatePicker v-model="showStartDate" locale="en" :format="formatDate" :enable-time-picker="false" week-start="0" position="left" placeholder="ex) 2025-01-01" auto-apply />
                                            </div>
                                            <div class="row">
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select03 }" @click.prevent="activeselect03">Цаг сонгоно уу</a>
                                                    <slide-up-down :active="select03" class="select-option">
                                                        <a href="" class="select-option--btn" v-for="i in 23">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                                :
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select04 }" @click.prevent="activeselect04">Минутыг сонгоно уу</a>
                                                    <slide-up-down :active="select04" class="select-option">
                                                        <a href="" class="select-option--btn" v-for="i in 59">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>Эмнэлгийн дүгнэлтийг хавсаргана уу</div>
                                <div class="cont">
                                    <input type="text" class="input" style="pointer-events: none;">
                                    <label class="file">
                                        <input type="file">
                                        <div class="main-button c-gray">Файл хавсаргах</div>
                                    </label>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>Холбоосыг хавсаргана уу</div>
                                <div class="cont">
                                    <input type="text" class="input">
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>Зургийг хавсаргана уу</div>
                                <div class="cont">
                                    <input type="text" class="input" style="pointer-events: none;">
                                    <label class="file">
                                        <input type="file">
                                        <div class="main-button c-gray">Файл хавсаргах</div>
                                    </label>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="botton-wrap">
                    <a href="" class="sub-button c-gray">Үгүй</a>
                    <a href="" class="main-button c-main">Тийм</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import VueDatePicker from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css';
    import SlideUpDown from 'vue-slide-up-down';

    export default {
        components: {
            VueDatePicker,
            SlideUpDown,
        },
        data() {
            return {
                showStartDate: null, // 초기값 설정
                formatDate: 'yyyy-MM-dd', // 원하는 날짜 형식 설정
                select01: false,
                select02: false,
                select03: false,
                select04: false,
            };
        },
        methods: {
            activeselect01() {
                this.select01 = !this.select01;
            },
            activeselect02() {
                this.select02 = !this.select02;
            },
            activeselect03() {
                this.select03 = !this.select03;
            },
            activeselect04() {
                this.select04 = !this.select04;
            },
        },
    }
</script>